import React, { useEffect, useRef, useState } from 'react'
import './manage-evals.styles.scss'

import { format, set } from 'date-fns'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faLink, faRefresh, faPrint, faPen, faEllipsisH, faEllipsisV, faTrash, faChartLine, faSquareArrowUpRight, faArchive } from '@fortawesome/free-solid-svg-icons'
import NewEvalModal from '../new-eval-modal/new-eval-modal.component'
import SearchBar from '../../SHARED/search-bar/search-bar.component'
import { properCase } from '../../../utils/properCase'
import { Link, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import EditEval from './edit-eval.component'
import EvalDataView from './eval-data-view.component'
import { ModalConfirm } from '../../modal/modal.component'
import FullPageLoader from '../../SHARED/loader/full-page-loader.component'

const ManageEvals = ({
  evalList
}) => {

  const [evalsToDisplay, setEvalsToDisplay] = useState({});
  const [newEval, setNewEval] = useState(false);
  const [showEvalDropdown, setShowEvalDropdown] = useState(null);
  const [ confirmMessage, setConfirmMessage ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const approveRef = useRef(() => {}); 
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(evalList);
    setEvalsToDisplay(evalList)
  }, [evalList])

  useEffect(() => {
    setShowEvalDropdown(null);
  }, [location])

  function search() {
    const searchText = document.getElementById('search-text').value.toLowerCase();
    if (!searchText) {
      setEvalsToDisplay(evalList);
      return;
    }
    const filteredEvals = Object.values(evalList).filter(ev => (
      (ev.title && ev.title.toLowerCase().includes(searchText)) ||
      (ev.id && ev.id.toLowerCase().includes(searchText)) ||
      (ev.platform && ev.platform.toLowerCase().includes(searchText)) ||
      (ev.source && ev.source.toLowerCase().includes(searchText))
    ));
    setEvalsToDisplay(filteredEvals);
  }
  // async function updateEvals() {
  //     const res = await UseCloudFunction('updateEvalList', {'data': 'some data'})
  //     console.log(res);
  // }

  function copyUrl(id) {
    const url = `${window.location.origin}/${id}`;
    navigator.clipboard.writeText(url);

    const el = document.getElementById(`${id}-tooltip`);
    if (!el) return;

    el.style.visibility = 'visible';
    const timeout = setTimeout(() => {
        document.getElementById(`${id}-tooltip`).style.visibility = 'hidden';
        timeout && clearTimeout(timeout);
    }, 2000);
  }

  function archiveEval(id) {
    console.log('archive', id);
    setConfirmMessage(`Are you sure you want to archive this evaluation? This action can be undone.`);
    approveRef.current = () => {
      continueArchive();
    }

    async function continueArchive() {

    }
  }

  return (
    <div className='manage_evals'>
      <Routes>
        <Route path="" element={
          <div className='manage_evals_content g-card'>
            {/* <div className='section-title'>
                  <span className='allcaps'>Manage Evaluations</span>
                </div>
                <div className='g-height-40'></div> */}
            <div className='section-head'>
              <h3>Manage Evaluations</h3>
              <div>
                {/* <button className='g-button button-small' onClick={() => updateEvals()}>
                      <FontAwesomeIcon icon={faRefresh} />
                    </button> */}
                <button 
                  className='g-button med-btn' 
                  onClick={() => navigate('/admin/create')}>
                  Create a New Evaluation<FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
            <hr />

            <SearchBar search={search} idLabel={'search-text'} />

            <table className='uk-table uk-table-striped'>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Created</th>
                  <th>Platform</th>
                  <th>Source</th>
                  <th className='centered'>CPDU</th>
                  <th className='centered'>Hours</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  (evalsToDisplay)
                    ?
                    Object.values(evalsToDisplay)
                      .sort((a, b) => (a.title.toLowerCase() > b.title.toLowerCase()) ? 1 : -1)
                      .map(ev => (
                        <tr key={ev.id}>
                          <td>
                            <b>{ev.title}</b><br />
                            <span className='meta'>{ev.id}</span>
                          </td>
                          <td>{format(new Date(ev.ts), "L/d/y")}</td>
                          <td>{ev.platform ? ev.platform.toUpperCase() : ev.type.toUpperCase()}</td>
                          <td>{properCase(ev.source)}</td>
                          <td className='centered'>{(ev.cpdu) ? 'Yes' : 'No'}</td>
                          <td className='centered'>{ev.hours}</td>
                          <td width="86px" className='dropdown-container'>
                            <div className='buttons'>
                              <button
                                className='g-button med-btn'
                                onClick={() => setShowEvalDropdown((showEvalDropdown === ev.id) ? null : ev.id)}>
                                <FontAwesomeIcon icon={faEllipsisH} />
                              </button>
                            </div>
                            {/* <div className='action-items'>
                              <a className='uk-link-reset' href={`/${ev.id}`} target='_blank'>
                                <FontAwesomeIcon icon={faLink} />
                              </a>
                              <a className='uk-link-reset' href={`/admin/evals/${ev.id}/edit`}>
                                <FontAwesomeIcon icon={faPen} />
                              </a>
                              {
                                (ev.cpdu && ev.hours > 0) &&
                                <a className='uk-link-reset' href={`/print/${ev.printId}`}>
                                  <FontAwesomeIcon icon={faPrint} />
                                </a>
                              }
                            </div> */}
                            <div className={`eval_more_dropdown ${(showEvalDropdown === ev.id) ? 'active' : ''
                              }`}>
                              <div className='eval_more_dropdown_menu'>
                                <div className='g-tooltip'>
                                  <span 
                                    className='g-tooltip-text'
                                    id={`${ev.id}-tooltip`}>Copied!
                                  </span>
                                  <button 
                                    className='g-button text-only' 
                                    onClick={() => copyUrl(ev.id)}>
                                    <FontAwesomeIcon icon={faLink} />
                                    <span>Copy Link</span>
                                  </button>
                                </div>
                                <Link to={`/${ev.id}`} target="_blank">
                                  <button className='g-button text-only'>
                                    <FontAwesomeIcon icon={faSquareArrowUpRight} />
                                    <span>View</span>
                                  </button>
                                
                                </Link>
                                <Link to={`/admin/evals/${ev.id}/data`}>
                                  <button className='g-button text-only'>
                                    <FontAwesomeIcon icon={faChartLine} />
                                    <span>Data</span>
                                  </button>
                                </Link>
                                <Link to={`/admin/evals/${ev.id}/edit`} className='disabled'>
                                  <button className='g-button text-only'>
                                    <FontAwesomeIcon icon={faPen} />
                                    <span>Edit</span>
                                  </button>
                                </Link>
                                <button 
                                  className='g-button text-only disabled' 
                                  onClick={() => archiveEval(ev.id)}>
                                  <FontAwesomeIcon icon={faArchive} />
                                  <span>Archive</span>
                                </button>
                                <Link 
                                  className={`disabled ` + 
                                    !ev.cpdu || ev.hours === 0 ? 'disabled' : ''
                                  }
                                  to={`/admin/evals/${ev.id}/delete`}>
                                    <button className={`g-button text-only`}>
                                      <FontAwesomeIcon icon={faPrint} />
                                      <span>Print EOC</span>
                                    </button>
                                </Link>
                                
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    : <tr><td></td></tr>
                }
              </tbody>
            </table>
          </div>
        }></Route>
        <Route path="/:evalId/edit" element={
          <EditEval />
        } />
        <Route path="/:evalId/data" element={
          <EvalDataView />
        } />
      </Routes>
      <NewEvalModal show={newEval} close={() => setNewEval(false)} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} message={'Processing...'} />
    </div>
  )
}

export default ManageEvals